import { message, Modal, Table, Space, Button, Select, Form, Input, Pagination, DatePicker } from "antd";
import { useParams } from 'react-router-dom';
import { useEffect, useRef, useState } from "react";
import useWebPost from "../../utils/useWebPost";
import FullHeightLayout from '../../components/FullHeightLayout';
import { checkp, formatDate, dayjsDate, formatDate2, ensureValidUrl,exportToCSV } from '../../utils/functions'
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import CustModal from "../../components/ShowModal";
import ProjectImport from "../../components/Tbimport";

const { Option } = Select;
const { TextArea } = Input;
const titleTxt={"1":"财务账号","2":"公司内部账号","3":"合作单位账号","4":"特种作业账号","6":"办公用账号","5":"其它账号"};
function AccountManagement() {
    const { type } = useParams();
    const webPost = useWebPost();
    const [modalVisible, setModalVisible] = useState(false);
    const [modal2Visible, setModal2Visible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({});
    const [total, setTotal] = useState(0);
    const [freshData, setfreshData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const pageSizeOptions = [10, 20, 50, 100, 500];
    const [mcolumns, setMcolumns] = useState([]);
    const [form] = Form.useForm();
    const [editingRecord, setEditingRecord] = useState(null);
    const loadingRef = useRef();
    const [mmtype, setMMtype] = useState('');
    const [canEdit, setCanEdit] = useState(false);
    const [titles, setTitles] = useState({});
    useEffect(() => {
        setCurrentPage(1);
        setFilters({});
        setfreshData(Math.random());
        let canmod = false, mtype = (type === '5' || type === '6') ? 'ac' : 'el';
        canmod = (type === '1' && checkp(['zhwlbaa'])) || (type === '2' && checkp(['zhwlbbb'])) || (type === '3' && checkp(['zhwlbcc'])) || (type === '4' && checkp(['zhwlbdd']))
            || (type === '5' && checkp(['zhwlbee'])) || (type === '6' && checkp(['zhwlbff']));
        setMMtype(mtype);
        setCanEdit(canmod);
        if (mtype === 'ac') {
            setTitles({ "login_url": '使用人', "handling_time": '办理时间', "handler_info": '其它' });
        } else {
            setTitles({ "login_url": '登入网址', "handling_time": '办理时间', "handler_info": '经办人/电话' });
        }
        const columns = [
            {
                title: '序号',
                dataIndex: 'sn',
                key: 'sn',
                width: 80,
                fixed: 'left',
                render: (text, record, rowIndex) => {
                    return rowIndex + 1 + (currentPage - 1) * pageSize;
                },
            },
            { title: '名称', dataIndex: 'name', key: 'name' },
            { title: '登入渠道', dataIndex: 'login_channel', key: 'login_channel' },
            mtype === 'el' && {
                title: '登入网址', dataIndex: 'login_url', key: 'login_url', render: (v) => {
                    const validUrl = ensureValidUrl(v);
                    if (!validUrl) {
                        return <span style={{ color: '#999' }}>无效：{v}</span>;
                    }
                    return (<a href={validUrl} target="_blank" rel="noopener noreferrer"> {v} </a>);
                }
            },
            mtype === 'ac' && { title: '使用人', dataIndex: 'login_url', key: 'login_url' },
            { title: '登录账号', dataIndex: 'login_account', key: 'login_account' },
            { title: '登录密码', dataIndex: 'login_password', key: 'login_password' },
            { title: '注册手机', dataIndex: 'register_phone', key: 'register_phone' },
            mtype === 'el' && { title: '注册邮箱', dataIndex: 'register_email', key: 'register_email' },
            mtype === 'el' && { title: '用户名称', dataIndex: 'user_name', key: 'user_name' },
            mtype === 'el' && { title: 'CA锁', dataIndex: 'ca_lock', key: 'ca_lock' },
            mtype === 'el' && { title: '归档序号', dataIndex: 'archive_number', key: 'archive_number' },
            mtype === 'el' && { title: 'CA保管单位', dataIndex: 'ca_keeper_unit', key: 'ca_keeper_unit' },
            mtype === 'el' && { title: '办理时间', dataIndex: 'handling_time', key: 'handling_time', render: (date) => formatDate(date) },
            { title: '有效期', dataIndex: 'validity_period', key: 'validity_period', render: (date) => formatDate(date) },
            mtype === 'el' && { title: '使用情况', dataIndex: 'usage_status', key: 'usage_status' },
            mtype === 'el' && { title: '经办人/电话', dataIndex: 'handler_info', key: 'handler_info' },
            mtype === 'ac' && { title: '其它', dataIndex: 'handler_info', key: 'handler_info' },
            { title: '备注', dataIndex: 'remarks', key: 'remarks' },

        ].filter(Boolean);
        if (canmod) {
            columns.push({
                title: '操作',
                key: 'action',
                width: 150,
                render: (_, record) => (
                    <Space size="middle">
                        <Button
                            type="link"
                            icon={<EditOutlined />}
                            onClick={() => showModal(record)}
                        >
                            修改
                        </Button>
                        {/* <Button
                            type="link"
                            danger
                            icon={<DeleteOutlined />}
                            onClick={() => handleDelete(record.id)}
                        >
                            删除
                        </Button> */}
                    </Space>
                ),
            })
        }
        setMcolumns(columns);

    }, [type]);
    useEffect(() => {
        const fetchItems = () => {
            if (loadingRef.current) return;
            loadingRef.current = true;
            setLoading(true);
            try {
                const params = { type, page: currentPage, limit: pageSize, ...filters };
                webPost('AccInfoList', params).then((response) => {
                    if (response && response.data) {
                        if (response.total < 1) {
                            message.info('未找到匹配数据');
                        }
                        setData(response.data);
                        setTotal(response.total);
                    }
                })
            } catch (e) {
                setData([]);
                setTotal(0);
            } finally {
                loadingRef.current = false;
                setLoading(false);
            }
        }
        fetchItems();
    }, [currentPage, pageSize, filters, freshData]);



    const showModal = (record = null) => {
        setEditingRecord(record);
        if (record) {
            form.setFieldsValue({
                ...record,
                handling_time: dayjsDate(record?.handling_time),
                validity_period: dayjsDate(record?.validity_period),
            });
        } else {
            form.resetFields();
        }
        setModalVisible(true);
    };
    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            const payload = {
                ...values, id: editingRecord?.id || 0, type,
                handling_time: formatDate2(values?.handling_time),
                validity_period: formatDate2(values?.validity_period),
            };

            const res = await webPost('AccInfoSave', payload);
            if (res) {
                message.success(editingRecord ? '更新成功' : '新增成功');
                saveSuccess();
            }
        } catch (err) {
            console.error('表单验证或提交错误:', err);
        }
    };

    // 删除记录
    const handleDelete = async (id) => {
        Modal.confirm({
            title: '确认删除？',
            content: '此操作不可恢复',
            onOk: async () => {
                const res = await webPost('AccInfoDel', { id, type });
                if (res) {
                    message.success('删除成功');
                    saveSuccess();
                } else {
                    message.error('删除失败');
                }
            },
        });
    };
    const handleModalClose = () => {
        setModalVisible(false);
        setEditingRecord(null);
    }
    const saveSuccess = () => {
        setfreshData(Math.random()); //强制刷新数据
        handleModalClose();
    };
    const onPageChange = (page, size) => {
        setCurrentPage(page);
        if (size !== pageSize) setPageSize(size);
    };
    return (
        <FullHeightLayout
            headerContent={
                <Space style={{ 'display': 'flex', 'width': '100%' }}>
                    <Input value={filters?.mc} placeholder='名称、登入渠道、经办人/电话' onChange={(e) => { setFilters(prev => ({ ...prev, mc: e.target.value })) }} />
                    <div style={{ 'flex': 1 }}></div>
                    {canEdit && (<><Button type="primary" icon={<PlusOutlined />} onClick={() => showModal()}>
                        新建账号
                    </Button>
                        <Button type="primary" onClick={() => setModal2Visible(true)}>
                            批量上传
                        </Button>
                        <Button type="primary" onClick={() => exportToCSV(data, mcolumns, titleTxt[type])}>
                            下载本页数据
                        </Button>
                    </>)}
                </Space>}
            bodyContent={
                <>
                    <Table
                        columns={mcolumns}
                        dataSource={data}
                        rowKey="id"
                        loading={loading}
                        pagination={false}
                        bordered
                        scroll={{
                            x: 'max-content',
                            y: 'calc(100% - 20px)',
                        }}
                        tableLayout="fixed"
                    />
                    <CustModal
                        title={editingRecord ? '编辑账号' : '创建新账号'}
                        open={modalVisible}
                        onOk={handleOk}
                        onCancel={() => setModalVisible(false)}
                        okText="保存"
                        cancelText="取消"
                        width={700}
                    >
                        <Form form={form} layout="vertical">
                            <Form.Item name="name" label="名称" rules={[{ required: true, message: '请输入名称' }]}>
                                <Input />
                            </Form.Item>
                            <Form.Item name="login_channel" label="登入渠道">
                                <Input />
                            </Form.Item>
                            <Form.Item name="login_url" label={titles.login_url}>
                                <Input />
                            </Form.Item>
                            <Form.Item name="login_account" label="登录账号">
                                <Input />
                            </Form.Item>
                            <Form.Item name="login_password" label="登录密码">
                                <Input />
                            </Form.Item>
                            <Form.Item name="register_phone" label="注册手机">
                                <Input />
                            </Form.Item>
                            {
                                mmtype === 'el' && (
                                    <>
                                        <Form.Item name="register_email" label="注册邮箱">
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name="user_name" label="用户名称">
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name="ca_lock" label="CA锁">
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name="archive_number" label="归档序号">
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name="ca_keeper_unit" label="CA保管单位">
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name="handling_time" label={titles.handling_time}>
                                            <DatePicker style={{ width: '100%' }} />
                                        </Form.Item>
                                    </>
                                )
                            }

                            <Form.Item name="validity_period" label="有效期">
                                <DatePicker style={{ width: '100%' }} />
                            </Form.Item>
                            {
                                mmtype === 'el' && (
                                    <>


                                        <Form.Item name="usage_status" label="账号当前使用情况">
                                            <Select placeholder="请选择">
                                                <Option value="使用中">使用中</Option>
                                                <Option value="停用">停用</Option>
                                                <Option value="待激活">待激活</Option>
                                            </Select>
                                        </Form.Item>

                                    </>
                                )
                            }
                            <Form.Item name="remarks" label="备注">
                                <TextArea rows={3} />
                            </Form.Item>
                            <Form.Item name="handler_info" label={titles.handler_info}>
                                <Input />
                            </Form.Item>
                        </Form>
                    </CustModal>

                    <ProjectImport Dbname={"account_info"} otherParams={{ "type": type }} visible={modal2Visible} onSave={() => {setfreshData(Math.random()); setModal2Visible(false)}} onClose={() => setModal2Visible(false)} />
                </>
            }
            footerContent={
                <div style={{
                    display: 'flex', justifyContent: 'flex-end',
                    alignItems: 'center',
                }}>
                    <Pagination
                        current={currentPage}
                        pageSize={pageSize}
                        total={total}
                        showSizeChanger
                        showQuickJumper
                        showTotal={(total, range) => `第 ${range[0]}-${range[1]} 条，共 ${total} 条`}
                        onChange={onPageChange}
                        pageSizeOptions={pageSizeOptions}
                    />
                </div>
            }
        />
    )
}


export default AccountManagement;
